<template>
    <div>
      <div v-html="renderedTable"></div>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        markdownData: "" // 后台返回的 Markdown 数据
      };
    },
    computed: {
      renderedTable() {
        return this.parseMarkdownTable(this.markdownData);
      }
    },
    methods: {
      parseMarkdownTable(markdown) {
        // 使用正则表达式提取表格部分
        const tableRegex = /\|[^|]+\|\|[^|]+\|/g;
        const matches = markdown.match(tableRegex);
        if (!matches) return '';
  
        // 解析每一行
        const parsedRows = matches.map(row => {
          const cols = row.split('||').map(col => col.trim().replace(/^\|/, '').replace(/\|$/, ''));
          return cols;
        });
  
        // 生成 HTML 表格
        let html = '<table border="1">';
        parsedRows.forEach((rowData, index) => {
          html += '<tr>';
          rowData.forEach(cellData => {
            html += index === 0 ? `<th>${cellData}</th>` : `<td>${cellData}</td>`;
          });
          html += '</tr>';
        });
        html += '</table>';
  
        return html;
      }
    },
    mounted() {
      // 模拟从后台获取数据
      this.markdownData = `
  五、数据图表
  | 企业名称 || 市场份额（%） |----------------||---------------| BOSCH || 28.00 | ST || 18.00 | Murata || 12.00 | NXP || 11.00 | 士兰微 || 9.00 | 美新半导体 || 7.00 | 其他 || 10.00 | 明皜传感 || 4.00 | 矽睿科技 || 1.00 |
  
  市场集中度对比图
  
  六、结论
  2022年中国MEMS加速度计市场呈现**“寡头主导、尾部分散”**的格局，建议企业通过技术升级、并购整合或聚焦细分市场提升竞争力，同时警惕新技术的替代风险。
  `;
    }
  };
  </script>
  
  <style scoped>
  
   
  </style>